export default {
      id: "small-info-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-info",
      toString: function () {
        return this.url;
      }
    }